import { createFolioSearchClient } from '../folioSearchClient';

export const clientSearch = createFolioSearchClient({
	additionalSearchParameters: {
		sort_by: 'name:asc',
	},
});
